import { Routes } from '@angular/router';

import { ShellComponent } from './layout/shell.component';
import { authGuard } from './core/auth/guards/auth.guard';
import { permissionGuard } from './core/auth/guards/permission.guard';

export const routes: Routes = [
	{
		path: '',
		component: ShellComponent,
		canActivate: [authGuard],
		children: [
			{ path: '', pathMatch: 'full', redirectTo: 'equipos' },
			{
				path: 'equipos',
				canActivate: [authGuard, permissionGuard],
				data: { requiredPermission: 'module:devices' },
				loadComponent: () =>
					import('./features/equipment/equipment.page').then((m) => m.EquipmentPage)
			},
			{
				path: 'usuarios',
				canActivate: [authGuard, permissionGuard],
				data: { requiredPermission: 'module:users' },
				loadComponent: () => import('./features/users/users.page').then((m) => m.UsersPage)
			},
			{
				path: 'fabricantes',
				canActivate: [authGuard, permissionGuard],
				data: { requiredPermission: 'module:manufacturer' },
				loadComponent: () => import('./features/manufacturer/manufacturer').then((m) => m.Manufacturer)
			},
			{
				path: 'proveedores',
				canActivate: [authGuard, permissionGuard],
				data: { requiredPermission: 'module:vendor' },
				loadComponent: () => import('./features/vendors/vendors').then((m) => m.Vendors)
			},
			{
				path: 'entidades',
				canActivate: [authGuard, permissionGuard],
				data: { requiredPermission: 'module:clients' },
				loadComponent: () => import('./features/clients/clients').then((m) => m.Clients)
			},
			{
				path: 'archivos',
				loadComponent: () => import('./features/files/files').then((m) => m.Files)
			},
			{
				path: 'cronograma',
				canActivate: [authGuard, permissionGuard],
				data: { requiredPermission: 'module:schedule' },
				loadComponent: () => import('./features/schedule/schedule').then((m) => m.Schedule)
			},
			{
				path: 'protocolos',
				canActivate: [authGuard, permissionGuard],
				data: { requiredPermission: 'module:maintenance' },
				loadComponent: () =>
					import('./features/maintenance-protocols/maintenance-protocols.page').then(
						(m) => m.MaintenanceProtocolsPage
					)
			},
			{
				path: 'mantenimientos',
				canActivate: [authGuard, permissionGuard],
				data: { requiredPermission: 'module:maintenance' },
				loadComponent: () =>
					import('./features/maintenance-sessions/maintenance-sessions.page').then(
						(m) => m.MaintenanceSessionsPage
					)
			},
			{
				path: 'mantenimientos/:id',
				canActivate: [authGuard, permissionGuard],
				data: { requiredPermission: 'module:maintenance' },
				loadComponent: () =>
					import('./features/maintenance-sessions/maintenance-session-detail.page').then(
						(m) => m.MaintenanceSessionDetailPage
					)
			},
			{
				path: 'exportar',
				canActivate: [authGuard, permissionGuard],
				data: { requiredPermission: 'takeout:write' },
				loadComponent: () =>
					import('./features/takeout/takeout.page').then((m) => m.TakeoutPage)
			},
			{
				path: 'perfil',
				canActivate: [authGuard, permissionGuard],
				data: { requiredPermission: 'module:profile' },
				loadComponent: () =>
					import('./features/profile/profile.page').then((m) => m.ProfilePage)
			}

		]
	},
	{
		path: 'callback',
		loadComponent: () =>
			import('./core/auth/components/auth-callback/auth-callback.component').then(
				(m) => m.AuthCallbackComponent
			)
	},
	{ path: '**', redirectTo: 'equipos' }
];
